import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, onMounted } from 'vue';
import { store } from '@/store';
import MiniBasketItemB2B from '@/ui/shared/MiniBasketItemB2B.vue';
import BasketViewModel = Vertica.LouisPoulsen.Application.Commerce.ViewModels.Business.BasketViewModel;


export default /*#__PURE__*/_defineComponent({
  __name: 'MiniBasketB2B',
  emits: ["close"],
  setup(__props, { emit }: { emit: ({(e: 'close'): void}), expose: any, slots: any, attrs: any }) {



const basket = computed<BasketViewModel>(() => store.getters['basket/basket']);
const lineItems = computed<LineItemViewObject[]>(() => store.getters['basket/lineItems']);

const basketUrl = computed<string>(() => store.getters['app/basketUrl']);
const catalogRootUrl = computed<string>(() => store.getters['app/catalogRootUrl']);

const buttonIsSpinning = ref<boolean>(false);

onMounted(() => {
    store.dispatch('basket/updateShippingCostB2B');
});

function close() {
    emit('close');
}

return { __sfc: true,emit, basket, lineItems, basketUrl, catalogRootUrl, buttonIsSpinning, close, MiniBasketItemB2B }
}

})